import { Directive } from '@angular/core';
import { provideJsonEditor } from '@examdojo/core/json-editor';
import questionItemsSchema from '@settings/question_items_schema.json';

@Directive({
  selector: '[dojoQuestionItemsJsonEditor]',
  providers: [provideJsonEditor(questionItemsSchema)],
  standalone: true,
})
export class QuestionItemsJsonEditorDirective {}
